import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Avatar from './avatar';
import CoverImage from './cover-image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import Markdown from 'markdown-to-jsx';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
export default function HeroPost(_ref) {
  var posts = _ref.posts;
  var lang = true ? window.navigator.language.includes('fr') ? 'fr' : 'en' : 'en';

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var heroPost = posts.find(function (post) {
    return post.isHero;
  }) || posts[0];
  return /*#__PURE__*/_jsxs("section", {
    children: [/*#__PURE__*/_jsx("div", {
      className: "mb-8 md:mb-16",
      children: /*#__PURE__*/_jsx(CoverImage, {
        post: heroPost
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "mb-20 md:grid md:grid-cols-2 md:col-gap-16 lg:col-gap-8 md:mb-28",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h3", {
          className: "mb-4 text-4xl leading-tight lg:text-6xl",
          children: /*#__PURE__*/_jsx(Link, {
            href: "/blog/".concat(heroPost === null || heroPost === void 0 ? void 0 : heroPost.slug),
            children: /*#__PURE__*/_jsx("a", {
              className: "hover:underline",
              children: heroPost === null || heroPost === void 0 ? void 0 : heroPost.title
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "mb-4 text-lg md:mb-0",
          children: dayjs(heroPost === null || heroPost === void 0 ? void 0 : heroPost.date_created).locale(lang).format('dddd DD MMMM YYYY')
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: "mb-4 text-lg leading-relaxed prose",
          children: /*#__PURE__*/_jsx(Markdown, {
            options: {
              forceBlock: true
            },
            children: heroPost === null || heroPost === void 0 ? void 0 : heroPost.subtitle
          })
        }), /*#__PURE__*/_jsx(Avatar, {
          post: heroPost
        })]
      })]
    })]
  });
}